// ── a real screenshot, inline ───────────────────────────────────────────────
// `:::shot <name> <caption>` in a guide or a docs page draws the capture
// `public/guides/shots/<name>.webp`, made by scripts/guide-shots.mjs from the
// REAL app (the dashboard on demo data, the real signup, the real birth, the
// real chat window), painted in the guide's own ground and cropped to the one
// piece of UI the step is about. Its size comes from lib/guides/shots.json,
// which the script writes, so the page reserves the exact box and nothing
// jumps as it loads.
//
// A name the script has not captured yet falls back to the designed figure of
// the same name (GuideFigure), and failing that draws nothing.

import React from "react";
import SHOTS from "../../lib/guides/shots.json";
import { renderGuideFigure } from "./GuideFigure";
import "./guide-figures.css";

type ShotMeta = { w: number; h: number; v?: string };
const TABLE = SHOTS as Record<string, ShotMeta>;

export function hasShot(name: string): boolean {
  return !!TABLE[name];
}

export function shotSrc(name: string): string | null {
  const m = TABLE[name];
  return m ? `/guides/shots/${name}.webp${m.v ? `?v=${m.v}` : ""}` : null;
}

/** draw a shot by name (or its designed stand-in), with its caption */
export function renderGuideShot(name: string, caption: string, key: string): React.ReactNode {
  const m = TABLE[name];
  if (!m) return renderGuideFigure(name, caption, key);
  return (
    <figure key={key} className="gshot" data-shot={name}>
      {/* eslint-disable-next-line @next/next/no-img-element -- a fixed, pre-sized capture; the optimiser adds nothing */}
      <img src={shotSrc(name)!} width={m.w} height={m.h} alt={caption || name.replace(/-/g, " ")} loading="lazy" decoding="async" draggable={false} />
      {caption && <figcaption className="gf__cap">{caption}</figcaption>}
    </figure>
  );
}
